/**
 * The texts of the shared course screens (D-107): the IELTS keeps its keys (`ielts.*`); the TCF
 * reads `academyCourse.tcf.*` first and falls back on the same key of the IELTS when the text is
 * the same for both exams. Only the texts change, never the screens.
 */

import { contentLanguage } from "@agencyos/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { GOETHE_CODE, IELTS, TEF, useActiveExam } from "./exam";

export function useCourseExam(): string {
  return useActiveExam().exam;
}

export function useCourseText(exam: string) {
  const { t } = useTranslation();
  const ct = useCallback(
    (key: string, options?: Record<string, unknown>): string =>
      exam === IELTS
        ? t(`ielts.${key}`, options ?? {})
        : exam === TEF
          ? t([`tef.course.${key}`, `academyCourse.tcf.${key}`, `ielts.${key}`], options ?? {})
          : exam === GOETHE_CODE
            ? t([`goethe.course.${key}`, `academyCourse.tcf.${key}`, `ielts.${key}`], options ?? {})
            : t([`academyCourse.tcf.${key}`, `ielts.${key}`], options ?? {}),
    [exam, t],
  );
  return { ct, contentLang: contentLanguage(exam) };
}
